/**
 * @generated SignedSource<<cf847296ae90a36424d5c1f667f2de39>>
 * @relayHash 7e8b64159ea029135d2d13201250adfe
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID ca5061c8600b5ca60e7da2c0d6475ba0fd46e490866e5f1e5c1ce7fb793bc241

import type { ConcreteRequest } from 'relay-runtime';
export type OnboardingStateLabelsQueryQuery$variables = {
  contentId: string;
  status?: ReadonlyArray<string | null | undefined> | null | undefined;
};
export type OnboardingStateLabelsQueryQuery$data = {
  readonly content: {
    readonly nodes: ReadonlyArray<{
      readonly id: string | null | undefined;
      readonly labels: {
        readonly nodes: ReadonlyArray<{
          readonly id: string | null | undefined;
          readonly label: string | null | undefined;
        } | null | undefined> | null | undefined;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
};
export type OnboardingStateLabelsQueryQuery = {
  response: OnboardingStateLabelsQueryQuery$data;
  variables: OnboardingStateLabelsQueryQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contentId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "status"
  }
],
v1 = {
  "kind": "ScalarField",
  "name": "id"
},
v2 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "contentId"
      },
      {
        "kind": "Variable",
        "name": "status",
        "variableName": "status"
      }
    ],
    "concreteType": "PaginatedContentListWithChild",
    "kind": "LinkedField",
    "name": "content",
    "plural": false,
    "selections": [
      {
        "concreteType": "Content",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          (v1/*: any*/),
          {
            "concreteType": "PaginatedLabelList",
            "kind": "LinkedField",
            "name": "labels",
            "plural": false,
            "selections": [
              {
                "concreteType": "Label",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  (v1/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "label"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "OnboardingStateLabelsQueryQuery",
    "selections": (v2/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "OnboardingStateLabelsQueryQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "7e8b64159ea029135d2d13201250adfe",
    "id": "ca5061c8600b5ca60e7da2c0d6475ba0fd46e490866e5f1e5c1ce7fb793bc241",
    "metadata": {},
    "name": "OnboardingStateLabelsQueryQuery",
    "operationKind": "query",
    "text": "query OnboardingStateLabelsQueryQuery($contentId:ID!,$status:[String]){content(id:$contentId,status:$status){nodes{id,labels{nodes{id,label}}}}}"
  }
};
})();

(node as any).hash = "c90950d9deff1ce1c91a765ae6f09d2d";

export default node;
